const { onlyNumericNormalize, SPACE } = require('../helpers');

const states = {
  GU: 'Guam'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Guam',
  code: 'GU',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City', width: 0.5 },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'State',
      width: 0.5
    },
    zipCode: {
      label: 'Zip Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'stateCode', SPACE, 'zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', 'stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^969[1-3]{1}[0-1]{1}$/),
      error: 'Must be 5 numbers between 96910 and 96931'
    }
  ]
};
